import { Global } from '../state/Global';
import { createSelector } from 'reselect';
import _get from 'lodash/get';
import { mapEcommercePlanType } from 'utils/ecommerceUtils';

const ecommerceState = (state: Global) => {
  return state.app.get('ecommerce');
};

const selectEcommercePlan = createSelector(
  ecommerceState,
  (ecommerce) => {
    return mapEcommercePlanType(_get(ecommerce, 'account.plan', ''));
  }
);

const selectEcommerceSupported = createSelector(
  ecommerceState,
  (ecommerce) => {
    return _get(ecommerce, 'account.isEcommerceSupported', false);
  }
);

const selectEcommerceLoading = createSelector(
  ecommerceState,
  (ecommerce) => {
    return ecommerce.loading;
  }
);

export {
  selectEcommercePlan,
  selectEcommerceSupported,
  selectEcommerceLoading
};
